import React from 'react';
import { useUser } from '../../hooks/useUser';
import { useAuth } from '../../hooks/useAuth';
import './UserProfile.css';

interface UserProfileProps {
  onClose?: () => void;
}

export const UserProfile: React.FC<UserProfileProps> = ({ onClose }) => {
  const { username, handler, system, planet, organizations } = useUser();
  const { getUserData } = useAuth();
  const userData = getUserData();

  // Obtener el nombre completo (puede ser nick o user)
  const fullName = userData?.nick || userData?.user || username;
  const displayName = handler && handler !== username ? `${fullName} (${handler})` : fullName;

  // Formatear origen
  const origin = planet && system ? `${planet}, ${system}` : system || planet || 'Desconocido';

  return (
    <div 
      className="user-profile-container" 
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={(e) => e.stopPropagation()}
      onMouseLeave={(e) => e.stopPropagation()}
    >
      {/* Header con icono y nombre */}
      <div className="user-profile-header">
        <div className="user-profile-avatar">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="#8B7355" stroke="#665C54" strokeWidth="2"/>
            <path d="M20 12C17.79 12 16 13.79 16 16C16 18.21 17.79 20 20 20C22.21 20 24 18.21 24 16C24 13.79 22.21 12 20 12ZM20 22C16.67 22 10 23.56 10 27V28H30V27C30 23.56 23.33 22 20 22Z" fill="#D4C4A8"/>
          </svg>
        </div>
        <div className="user-profile-name-section">
          <h3 className="user-profile-name">{handler || username}</h3>
          <p className="user-profile-subtitle">Panel de control Corvus</p>
        </div>
      </div>

      {/* Panel de detalles */}
      <div className="user-profile-details">
        {/* Sección Usuario */}
        <div className="user-profile-section">
          <label className="user-profile-label">Usuario</label>
          <div className="user-profile-value">{displayName}</div>
        </div>

        {/* Sección Origen */}
        <div className="user-profile-section">
          <label className="user-profile-label">Origen</label>
          <div className="user-profile-value">{origin}</div>
        </div>

        {/* Sección Organizaciones */}
        {organizations && organizations.length > 0 && (
          <div className="user-profile-section">
            <label className="user-profile-label">Organizaciones</label>
            <div className="user-profile-organizations">
              {organizations.map((org: any, index: number) => {
                // Determinar si el usuario es admin en esta organización
                const isOrgAdmin = org.rol?.toLowerCase() === 'admin' || userData?.admin;
                const orgName = org.tag ? `${org.tag} - ${org.name}` : org.name;
                
                return (
                  <div key={org.id || org._id || index} className="user-profile-org-card">
                    <div className="user-profile-org-name">
                      {orgName}
                    </div>
                    <div className="user-profile-org-badges">
                      {isOrgAdmin && (
                        <span className="user-profile-badge user-profile-badge-admin">
                          Admin
                        </span>
                      )}
                      <span className="user-profile-badge user-profile-badge-member">
                        Miembro
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
